Vue.component("inspection-settings", {

    props: ["settings", "inspectionTypes"],

    data () {
        return {
            form: new AppForm({
                terms: this.settings.terms,
                signature_declaration: this.settings.signature_declaration,
                report_branding_bg_color: this.settings.report_branding_bg_color,
                report_branding_text_color: this.settings.report_branding_text_color,
                inspection_types: this.settings.inspection_types
            }),
            inspectionTypeOptions: this.inspectionTypes
        };
    },

    methods: {

        update () {

            App.patch("/settings/inspections/" + this.settings.id + "/update", this.form)
            .then(() => {
                toastr.success("Settings updated!");
            })
            .catch(error => {
                toastr.error("Error saving settings! " + error.message);
            });

        }

    }

});